import {createAction} from "@reduxjs/toolkit";

export const userLoginAction = createAction('userLogin', function prepare(token: string, tokenExpirationDate: number) {
    return {
        payload: {
            token,
            tokenExpirationDate
        },
    }
})